import React, { useEffect } from "react";
import { FormProvider } from "./FormContext";

import * as Const from "./_Const";
import AnimatedRoute from "./AnimatedRoute";
import ToasterBar from "./components/ToasterBar";

//
function App() {
  useEffect(() => {
    //zakaze vsem prvkum na strance vyvolani context menu prohlize pro zkopirovani, otevreni na dlasi strance atd
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    // Úklid při ukončení aplikace
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  return (
    <FormProvider>
      <AnimatedRoute />
      <ToasterBar />
    </FormProvider>
  );
}

export default App;
